<template>
	<div>
		<div class="content-i">
			<div class="content-box">
				<div class="row">
					<div class="col-8">
						<div class="element-wrapper">
							<h6 class="element-header">{{ t('coversheetsText', 'coversheetsText') }}</h6>
							<b-button variant="dark" class="mb-2" @click="goBack()">{{ t('backButtonText', 'backButtonText')}}</b-button>
							<div class="element-box">
								<form id="formGeneralDeliveryRules" v-on:submit.prevent="updateCustomerCoversheets">
									<div class="element-info">
										<!-- email coversheet line -->
										<div class="container">
											<div class="row text-center form-line form-group">
												<div class="boxCoversheet">
													<div class="mr-2 text-right">{{ t('emailCoversheetText', 'emailCoversheetText') }}</div>
												</div>
												<div class="mr-2 standardWidth">
													<b-form-select v-model="getCustomerCoversheets.email" :options="coversheetOptions" @change="checkStatusEmail()">
													</b-form-select>
												</div>
												<div class="mr-2">{{ t('onceEveryText', 'onceEveryText') }}</div>
												<input type="text" v-model="getCustomerCoversheets.email_frequency" class="mr-2 form-control inputWidth" :disabled="getCustomerCoversheets.email != 'defined'"> 
												<div class="mr-2">{{ t('monthsText', 'monthsText') }}</div>
												<div class="mr-2 textColour">{{ t('sentLastTimeOnText', 'sentLastTimeOnText') }}</div>
												<div v-if="getUserLevel == 3.00" class="form-line">
													<datePicker class="mr-2 standardWidth" v-model="getCustomerCoversheets.email_last_date" :config="datePickerConfig" :placeholder="'00/00/0000'"></datePicker>
													<div class="mr-2 textColour">DD-MM-YYYY</div>
												</div>
												<div v-else class="mr-2 textColour">{{getCustomerCoversheets.email_last_date}}</div>
											</div>
										</div>
										<!-- fax coversheet line -->
										<div class="container">
											<div class="row text-center form-line form-group">
												<div class="boxCoversheet">
													<div class="mr-2 text-right">{{ t('faxlCoversheetText', 'faxlCoversheetText') }}</div>
												</div>
												<div class="mr-2 standardWidth">
													<b-form-select v-model="getCustomerCoversheets.fax" :options="coversheetOptions" @change="checkStatusFax()">
													</b-form-select>
												</div>
												<div class="mr-2">{{ t('onceEveryText', 'onceEveryText') }}</div>
												<input type="text" v-model="getCustomerCoversheets.fax_frequency" class="mr-2 form-control inputWidth" :disabled="getCustomerCoversheets.fax != 'defined'">
												<div class="mr-2">{{ t('monthsText', 'monthsText') }}</div>
												<div class="mr-2 textColour">{{ t('sentLastTimeOnText', 'sentLastTimeOnText') }}</div>
												<div v-if="getUserLevel == 3.00" class="form-line">
													<datePicker class="mr-2 standardWidth" v-model="getCustomerCoversheets.fax_last_date" :config="datePickerConfig" :placeholder="'00/00/0000'"></datePicker>
													<div class="mr-2 textColour">DD-MM-YYYY</div>
												</div>
												<div v-else class="mr-2 textColour">{{getCustomerCoversheets.fax_last_date}}</div>
											</div>
										</div>
										<!-- post coversheet line -->
										<div class="container">
											<div class="row text-center form-line form-group">
												<div class="boxCoversheet">
													<div class="mr-2 text-right">{{ t('postCoversheetText', 'postCoversheetText') }}</div>
												</div>
												<div class="mr-2 standardWidth">
													<b-form-select v-model="getCustomerCoversheets.post" :options="coversheetOptions" @change="checkStatusPost()">
													</b-form-select>
												</div>
												<div class="mr-2">{{ t('onceEveryText', 'onceEveryText') }}</div>
												<input type="text" v-model="getCustomerCoversheets.post_frequency" class="mr-2 form-control inputWidth" :disabled="getCustomerCoversheets.post != 'defined'">
												<div class="mr-2">{{ t('monthsText', 'monthsText') }}</div>
												<div class="mr-2 textColour">{{ t('sentLastTimeOnText', 'sentLastTimeOnText') }}</div>
												<div v-if="getUserLevel == 3.00" class="form-line">
													<datePicker class="mr-2 standardWidth" v-model="getCustomerCoversheets.post_last_date" :config="datePickerConfig" :placeholder="'00/00/0000'"></datePicker>
													<div class="mr-2 textColour">DD-MM-YYYY</div>
												</div>
												<div v-else class="mr-2 textColour">{{getCustomerCoversheets.post_last_date}}</div>
											</div>
										</div>									
									</div>
									<b-button class="btn btn-success" type="submit">Update</b-button>
								</form>
								<ResponseInfo v-if="getResponseInfo.responseName == 'customerCoversheets'" class="mt-2"/>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import ResponseInfo from '@/components/ResponseInfo.vue'
import datePicker from 'vue-bootstrap-datetimepicker'

import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css'

export default {
	name: 'CustomerCoversheets',
		components: {
			ResponseInfo,
			datePicker
    },
	data() {
		return {
			customerId: this.$route.params.id,
			getDate: null,
			coversheetOptions: [
				{value: 'on', text: 'On'}, 
				{value: 'defined', text: 'As defined'},
				{value: 'off', text: 'Off'}],
			datePickerConfig: {
				format: 'DD/MM/YYYY',
				icons: {
          time: 'os-icon os-icon-calendar-time',
          date: 'os-icon os-icon-basic-2-259-calendar',
          up: 'os-icon os-icon-chevron-up',
          down: 'os-icon os-icon-chevron-down',
          previous: 'os-icon os-icon-chevron-left',
          next: 'os-icon os-icon-chevron-right',
          clear: 'os-icon os-icon-trash',
          close: 'os-icon os-icon-cancel-circle'
        },
				showClear: true
			}
		}
	},
	created() {
		this.$store.dispatch('manageCustomersStore/getCustomerCoversheets', this.customerId).then(() => {
			this.checkStatusEmail()
			this.checkStatusFax()
			this.checkStatusPost()
		})

	},
	methods: {
		checkStatusEmail() {
			if(this.getCustomerCoversheets.email != 'defined') {
				this.getCustomerCoversheets.email_frequency = null
			}
		},
		checkStatusFax() {
			if(this.getCustomerCoversheets.fax != 'defined') {
				this.getCustomerCoversheets.fax_frequency = null
			}
		},
		checkStatusPost() {
			if(this.getCustomerCoversheets.post != 'defined') {
				this.getCustomerCoversheets.post_frequency = null
			}
		},
		goBack() {
			this.$router.go(-1)
		},    
		updateCustomerCoversheets() {
			this.$store.dispatch('manageCustomersStore/updateCustomerCoversheets', {
				updatedCustomerCoversheets: this.getCustomerCoversheets,
				customerId: this.customerId,
				userLevel: this.getUserLevel
			}).then(this.$store.dispatch('manageCustomersStore/getCustomerCoversheets', this.customerId).then(() => {
				this.checkStatusEmail()
				this.checkStatusFax()
				this.checkStatusPost()
			}))
		}
	},
	computed: {
		...mapGetters(['getResponseInfo', 'getUserLevel']),
		...mapGetters('manageCustomersStore', ['getCustomerCoversheets'])
	}
}
</script>

<style scoped>
  .form-line {
    display: flex;
    align-items: center;
  }

	.boxCoversheet {
		width: 170px;
	}

	.standardWidth {
		width: 120px;
	}

	.inputWidth {
		width: 50px;
	}
	
	.textColour {
		color: #919191;
	}

</style>